import { render, staticRenderFns } from "./AnnouncementEdit.vue?vue&type=template&id=a92b3036&scoped=true"
import script from "./AnnouncementEdit.vue?vue&type=script&lang=js"
export * from "./AnnouncementEdit.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementEdit.vue?vue&type=style&index=0&id=a92b3036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92b3036",
  null
  
)

export default component.exports